import React from "react";
import {
  Card,
  Box,
  Typography,
  Grid,
  CardContent,
  CardActions,
} from "@material-ui/core";
import { Skeleton } from "@material-ui/lab";
import PoolCardStyle from "./PoolsStyle";

const SkeletonCard = () => {
  const classes = PoolCardStyle();

  return (
    <Card variant="outlined" className={classes.skeleton}>
      <Skeleton
        className={classes.media}
        variant="rect"
        animation="pulse"
        height={160}
      />
      <Grid
        container
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        className={classes.iconWrapper}
      >
        <Grid item>
          <Skeleton variant="circle" className={classes.avatar} />
        </Grid>
        <Grid item>
          <Skeleton variant="circle" className={classes.network} />
        </Grid>
      </Grid>
      <CardContent className={classes.content}>
        <Typography
          variant="h5"
          component="h2"
          gutterBottom
          className={classes.title}
        >
          <Skeleton variant="text" height={24} width={100} />
        </Typography>
        <Typography
          variant="body2"
          component="p"
          className={classes.description}
        >
          <Skeleton variant="text" />
          <Skeleton variant="text" />
        </Typography>
        <Grid container direction="column" className={classes.detailContainer}>
          <Grid item>
            <Grid
              container
              direction="row"
              justifyContent="space-between"
              alignItems="center"
            >
              <Grid item>
                <Typography>
                  <Skeleton variant="text" width={100} />
                </Typography>
              </Grid>
              <Grid item xs={true}>
                <Box border={"1px #ECF0F3 dashed"} marginX={"18px"}></Box>
              </Grid>
              <Grid item>
                <Skeleton variant="text" width={100} />
              </Grid>
            </Grid>
          </Grid>
          <Grid item>
            <Skeleton style={{ marginTop: "1rem" }} variant="text" />
          </Grid>
        </Grid>
      </CardContent>
      <CardActions>
        <Grid
          container
          direction="row"
          justifyContent="space-between"
          alignItems="center"
          className={classes.actionContainer}
        >
          <Skeleton
            variant="rect"
            className={classes.actionButton}
            height={40}
          />
        </Grid>
      </CardActions>
    </Card>
  );
};

export default SkeletonCard;
